import { useContext } from 'react';
import BusyContext from 'App/layout/busy/BusyContext';

export const useBusy = () => {
  const { busy, setBusy } = useContext(BusyContext);

  return { busy, setBusy };
};
